<!-- The top property assigned to ngStyle will be refactored as part of Quick Start Cart redesign-->
<div *ngIf="data?.calledBy !== 'weeklyad' && !isToasterALV2" class="popup popup-dark" [ngClass]="[data?.calledBy === 'ppms' ? 'popup--toaster--ppms' : 'popup--toaster', options?.class]" [ngStyle]="{'top':data?.calledBy === 'quantity-stepper-v3' ? options?.top : ''}" role="alert">
  <div class="popup__content">
      <div class="popup__content__icon">
          <ng-container *ngIf="data?.type === toasterTypeEnum.Success">
              <span class="svg-icon svg-success-filled"></span>
          </ng-container>
          <ng-container *ngIf="data?.type === toasterTypeEnum.Warning">
              <span class="svg-icon svg-warning-filled"></span>
          </ng-container>
          <ng-container *ngIf="data?.type === toasterTypeEnum.Error">
              <span class="svg-icon svg-error-filled"></span>
          </ng-container>
          <ng-container *ngIf="data?.type === toasterTypeEnum.Info">
              <span class="svg-icon svg-info-filled" aria-label="information"></span>
          </ng-container>
      </div>
      <span class="sr-only" id="toasterDescription">
        {{ data?.message }}, {{data.interactiveElement}}
      </span>
      <div id="toasterMessagev2" class="popup__content__text body-text-xs">
          {{ data?.message }}
          <ng-container *ngIf="data?.interactiveElement">
              <button id="toasterIntElem" class="popup__content__text__interactive-btn" (click)="interactiveElementEvent()" (keyup.Enter)="interactiveElementEvent()">{{data.interactiveElement}}</button>
          </ng-container>
      </div>
        <button (click)="closeToasterEvent()" (keyup.Enter)="closeToasterEvent()" id="toasterCloseBtnv2" aria-label="Close" class="close-toaster-btn popup__close-btn" aria-describedby="toasterDescription">
            <span class="svg-icon svg-close-white"></span>
        </button>
  </div>
</div>

<div *ngIf="data?.calledBy !== 'weeklyad' && isToasterALV2" class="pds-toasts pds-toasts-content" [ngClass]="[data?.calledBy === 'ppms' ? 'popup--toaster--ppms' : 'popup--toaster', options?.class]" role="alert" id="toasterAlV2" (keydown)="onKeyDown($event)" aria-live="polite">
    <div class="d-flex">
        <div class="mr-2">
            <ng-container *ngIf="data?.type === toasterTypeEnum.Success">
                <span class="pds-svg-positive-icon_inverse" aria-hidden="true"></span>
            </ng-container>
            <ng-container *ngIf="data?.type === toasterTypeEnum.Warning">
                <span class="pds-svg-warning-icon_inverse" aria-hidden="true"></span>
            </ng-container>
            <ng-container *ngIf="data?.type === toasterTypeEnum.Error">
                <span class="pds-svg-error-icon-large_inverse" aria-hidden="true"></span>
            </ng-container>
            <ng-container *ngIf="data?.type === toasterTypeEnum.Info">
                <span class="pds-svg-info-icon_inverse" aria-hidden="true"></span>
            </ng-container>
        </div>
        <span class="sr-only" id="toasterDescription">
            {{ data?.message }}, {{data.interactiveElement}}
          </span>
        <div id="toasterMessagev2" class="pds-toasts__body ml-1" aria-hidden="true" >
            <p class="text-m--snow m-0"> {{ data?.message }}</p>
        </div>
        <button
            id="toasterCloseBtnv2"
            (click)="closeToasterEvent(null, data?.title === 'order-amends-ota' && data?.type === toasterTypeEnum.Success)"
            (keyup.Enter)="closeToasterEvent(null, data?.title === 'order-amends-ota' && data?.type === toasterTypeEnum.Success)"
            class="pds-icon-btn pds-icon-btn-size_small pds-icon-btn-transparent--inverse-neutral d-flex align-items-center justify-content-center pds-toasts__close"
            aria-label="Close"
            aria-describedby="toasterDescription">
            <span class="pds-svg-close pds-icon-btn-transparent--inverse-neutral__icon"
                aria-hidden="true"></span>
        </button>
    </div>
    <ng-container *ngIf="data?.interactiveElement">
        <div class="pds-toasts__footer pt-2 ml-auto">
            <button
            id="toasterIntElem"
            (click)="interactiveElementEvent()"
            (keyup.Enter)="interactiveElementEvent()"
            class="pds-btn pds-btn-size__small pds-btn-outlined--inverse-neutral pds-toasts__button d-flex align-items-center justify-content-center"
            [attr.aria-label]="data?.interactiveElement">{{data?.interactiveElement}}</button>
        </div>
    </ng-container>
</div>


<ng-container *ngIf="data?.calledBy === 'weeklyad' && isOpen">
    <div class="popup mx-auto d-flex flex-column" [ngStyle]="{maxWidth: data?.width, 'background-color': data?.bgColor}">
        <div class="popup__content d-flex w-100">
            <div class="popup__content__text w-100">
                <div class="checkbox w-100" *ngIf="data?.hasCheckBox">
                    <label class="checkbox__group" for="checkboxMediumLabel" aria-label="Checkbox Label">
                        <span class="checkbox__label checkbox__label--md w-100">{{ data?.checkBoxLabel }}</span>
                        <input class="checkbox__input" type="checkbox" [checked]="isChecked" id="checkboxMediumLabel" (click)="trackAnalyticsEvents('opted-in', 'checkbox', isLearnMoreExpanded); onClickOfCheckbox()">
                        <span class="checkbox__checkmark"><span class="svg-checkmark"></span></span>
                    </label>
                </div>
                <div class="body-text-xs ml-4" *ngIf="data?.headerText !== ''">
                    {{ data?.headerText }}
                </div>
                <div class="body-text-xs ml-4" *ngIf="data?.unsubscribeText !== ''">
                    {{ data?.unsubscribeText }} <a role="button" tabindex="0" [attr.aria-label]="learnMoreAriaLabel" [attr.aria-expanded]="isLearnMoreExpanded" (click)="onClickExpandCollapse()" (keydown)="onLearnMoreKeyDown($event)">Learn more <span class="svg-caret-down" aria-hidden="true"></span></a>
                </div>
            </div>
            <div class="popup__content__buttons my-auto" *ngIf="data?.hasCloseButton">
                <button type="button" class="btn bg-white btn-circle--sm" [attr.aria-label]="data?.closeButtonAriaLabel || 'Close'" (click)="trackAnalyticsEvents('opted-out', undefined, isLearnMoreExpanded); closeToasterEvent(data?.closeAction)">
                    <span class="svg-icon svg-close-primary" aria-hidden="true"></span>
                </button>
            </div>
            <div class="popup__content__buttons my-auto" *ngIf="data?.hasAcceptButton">
                <button type="button" class="btn bg-white btn-circle--sm" [attr.aria-label]="data?.acceptButtonAriaLabel || 'Accept'" (click)="trackAnalyticsEvents('opted-in', undefined, isLearnMoreExpanded); closeToasterEvent(data?.approveAction)">
                    <span class="svg-icon svg-checkmark" aria-hidden="true"></span>
                </button>
            </div>
        </div>
        <div class="popup__content w-100 py-0" *ngIf="isLearnMoreExpanded">
            <p class="body-text-xs">{{ data?.learnMoreText }}</p> 
        </div>
        <div *ngIf="data?.hasSaveButton && isLearnMoreExpanded" class="mx-auto pb-2">
            <button class="btn btn-sm pds-btn-outlined--primary" (click)="trackAnalyticsEvents('save', undefined, isLearnMoreExpanded); closeToasterEvent(data?.approveAction)">Save</button>
        </div>
    </div>
</ng-container>
